/* eslint-disable */
import { useState } from "react";
import { Stack, Button } from "@mui/material";

import AddPointsDialog from "../../../pages/customer-360/CustomerDetail/AddPointsDialog";
import DeductPointsDialog from "../../../pages/customer-360/CustomerDetail/DeductPointsDialog";

const renderActionsCellContent = ({
  type,
  userRedemptionId,
  userRewardId,
  points,
  activityTypeName,
  activityTypeId,
  rewardTypeName,
  omneId,
  dateTime,
}) => {
  const [isShowAddPointsDialog, setIsShowAddPointsDialog] = useState(false);
  const [isShowDeductPointsDialog, setIsShowDeductPointsDialog] =
    useState(false);

  const handleClickEdit = () => {
    if (type === "EARN") {
      setIsShowAddPointsDialog(true);
    } else if (type === "BURN") {
      setIsShowDeductPointsDialog(true);
    }
  };

  const handleClickRefund = () => setIsShowAddPointsDialog(true);

  const renderActionButton = () => {
    if (type === "EARN") {
      return (
        <Button variant="secondary" size="small" onClick={handleClickEdit}>
          Edit
        </Button>
      );
    } else if (type === "BURN") {
      return (
        <>
          <Button variant="secondary" size="small" onClick={handleClickEdit}>
            Edit
          </Button>
          <Button variant="secondary" size="small" onClick={handleClickRefund}>
            Refund
          </Button>
        </>
      );
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems={"center"}>
      {renderActionButton()}
      <AddPointsDialog
        isShow={isShowAddPointsDialog}
        omneId={omneId}
        userRewardId={userRewardId}
        userRedemptionId={userRedemptionId}
        points={points}
        activityTypeName={activityTypeName}
        rewardTypeName={rewardTypeName}
        dateTime={dateTime}
        activityTypeId={activityTypeId}
        mode={type === "EARN" ? "EDIT" : type === "BURN" ? "REFUND" : ""}
        handleClose={() => setIsShowAddPointsDialog(false)}
      />
      <DeductPointsDialog
        activityTypeName={activityTypeName}
        rewardTypeName={rewardTypeName}
        omneId={omneId}
        userRedemptionId={userRedemptionId}
        userRewardId={userRewardId}
        dateTime={dateTime}
        points={points}
        mode="EDIT"
        isShow={isShowDeductPointsDialog}
        handleClose={() => setIsShowDeductPointsDialog(false)}
      />
    </Stack>
  );
};

const ActionsCell = params => {
  return renderActionsCellContent(params.value);
};

export default ActionsCell;
